import { IWidgetProps } from "decorator-form";
import { Button } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { css } from "styled-components";
import React from "react";

export enum Position {
    TOP = "top",
    TOP_LEFT = "top-left",
    TOP_RIGHT = "top-right",
    LEFT = "left",
    RIGHT = "right",
    CENTER = "center",
    BOTTOM = "bottom",
    BOTTOM_LEFT = "bottom-left",
    BOTTM_RIGHT = "bottom-right"
}

export const positionToCss = (position: Position) => {

    return position && css`
        display: flex;

        ${Position.TOP === position && css`
            align-items: center;
            flex-direction: column;
        `}

        ${Position.TOP_LEFT === position && css`
            align-items: flex-start;
            flex-direction: column;
        `}

        ${Position.TOP_RIGHT === position && css`
            align-items: flex-end;
            flex-direction: column;
        `}

        ${Position.LEFT === position && css`
            align-items: center;
            flex-direction: row;
        `}

        ${Position.RIGHT === position && css`
            align-items: center;
            flex-direction: row-reverse;
        `}

        ${Position.CENTER === position && css`
            align-items: center;
            justify-content: center;
            flex-direction: row;
        `}

        ${Position.BOTTOM === position && css`
            align-items: center;
            flex-direction: column-reverse;
        `}

        ${Position.BOTTOM_LEFT === position && css`
            align-items: flex-start;
            flex-direction: column-reverse;
        `}

        ${Position.BOTTM_RIGHT === position && css`
            align-items: flex-end;
            flex-direction: column-reverse;
        `}        
    `;
}

const PositionWidget: React.SFC<IWidgetProps<string>> = ({value, onChange}) => {
	return (
        <React.Fragment>
            <Button 
                icon={IconNames.CROSS}
                small={true} onClick={() => onChange(null)}
                style={{marginBottom: "10px"}}
            >
                Clear
            </Button>
            <div>
                <Button icon={IconNames.ARROW_TOP_LEFT} 
                    disabled={Position.TOP_LEFT === value}
                    onClick={() => onChange(Position.TOP_LEFT)}
                />
                <Button icon={IconNames.ARROW_UP} 
                    disabled={Position.TOP === value}
                    onClick={() => onChange(Position.TOP)}
                />
                <Button icon={IconNames.ARROW_TOP_RIGHT} 
                    disabled={Position.TOP_RIGHT === value}
                    onClick={() => onChange(Position.TOP_RIGHT)}
                />
            </div>
            <div>
                <Button icon={IconNames.ARROW_LEFT} 
                    disabled={Position.LEFT === value}
                    onClick={() => onChange(Position.LEFT)}
                />
                <Button icon={IconNames.ALIGN_CENTER} 
                    disabled={Position.CENTER === value}
                    onClick={() => onChange(Position.CENTER)}
                />
                <Button icon={IconNames.ARROW_RIGHT} 
                    disabled={Position.RIGHT === value}
                    onClick={() => onChange(Position.RIGHT)}
                />
            </div>
            <div>
                <Button icon={IconNames.ARROW_BOTTOM_LEFT} 
                    disabled={Position.BOTTOM_LEFT === value}
                    onClick={() => onChange(Position.BOTTOM_LEFT)}
                />
                <Button icon={IconNames.ARROW_DOWN} 
                    disabled={Position.BOTTOM === value}
                    onClick={() => onChange(Position.BOTTOM)}
                />
                <Button icon={IconNames.ARROW_BOTTOM_RIGHT} 
                    disabled={Position.BOTTM_RIGHT === value}
                    onClick={() => onChange(Position.BOTTM_RIGHT)}
                />
            </div>
        </React.Fragment>
    )
};

export default PositionWidget;


// WEBPACK FOOTER //
// ./src/common/form/widgets/PositionWidget.tsx